import React, { createContext, useState, useEffect, useContext } from "react";
import {
  getGroupsByUser,
  getGroupAdherents,
} from "./../services/groupServices";
import { useUser } from "./../pages/Home/UserContext";

// Création du contexte
const GroupContext = createContext();

// Fournisseur du contexte
export const GroupProvider = ({ children }) => {
  const { user } = useUser();
  const [pendingRequestsCount, setPendingRequestsCount] = useState(0);

  useEffect(() => {
    const fetchPendingRequests = async () => {
      if (!user?.userId) return;

      try {
        const groups = await getGroupsByUser(user.userId);
        let totalPending = 0;

        for (const group of groups) {
          const { adherents } = await getGroupAdherents(group.id);

          // Compter les adhérents avec le statut "pending"
          totalPending += adherents.filter(
            (adherent) => adherent.status === "pending"
          ).length;
        }

        setPendingRequestsCount(totalPending);
      } catch (error) {
        console.error(
          "Erreur lors de la récupération des demandes en attente :",
          error
        );
      }
    };

    fetchPendingRequests();
  }, [user]);

  return (
    <GroupContext.Provider
      value={{ pendingRequestsCount, setPendingRequestsCount }}
    >
      {children}
    </GroupContext.Provider>
  );
};

// Hook personnalisé pour utiliser le contexte
export const useGroup = () => useContext(GroupContext);
